<template>
   <div>
      <div class="rownew" v-click-outside="closeModel">
        <div :class="{'search-span': steps === 0 || steps === 4, 'search': steps !== 0 && steps !== 4,'analysis' : steps == 3}" v-if="role !== 'laboperator'">
          <div class="search-width">
            <div :class="steps == 0 || steps == 4 ?'search-button':'search'">
              <input
                type="text"
                class="search-input"
                id="search-input"
                :placeholder="placeholder"
                @input="setSearchStr"
                @keyup.enter="sendsearchReq"
              />
              <span class="search-icone-wrap right" :class="showClose ? 'right-close': 'right'">
                    <button class="btn" v-if="showClose && getSearchstr" @click="clearText" >
                        <CloseIcone></CloseIcone>
                    </button>
                    <img v-if="!loading" src="../../../images/dashboard/refresh.png" alt="#" @click="clear"/>
                    <img v-else class="loading-gif" src="../../../images/dashboard/reloading-gif.svg" alt="Refresh" />
             
              </span>
              <span class="search-icone-wrap left">
                <img src="../../../images/header/search_icone.svg" alt="#" />
              </span>
            </div>
          </div>
          <div v-if="showSearchAll & false"  class="btn-div">
            <button class="btn-search" @click = "sendsearchAll">Search All</button>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { parseAndConvertKitId } from "../../mixins/parseAndConvertKitId";
import Alert from "../../dashboard/Alert.vue";
import CloseIcone from "../../../images/shared/cancel";

export default {
  name: "Search",
  props: ['steps'],
  mixins: [parseAndConvertKitId],
  data() {
    return {
      inputWidth: false,
      showMenu: false,
      userProfile: [],
      searchKey: null,
      placeholder: 'Search',
      loading:false,
      showClose:false,
      showSearchAll:false
    };
  },
  components: {
    Alert,
    CloseIcone
  },
  async mounted() {
    this.userProfile = await this.profile();
    if(this.role == 'laboperator') {
      this.placeholder = 'Search Kit ID';
    }
    if (this.$store.getters.getComponentNum == 15) {
      document.getElementById("search-input").value = null;
    } else {
      document.getElementById("search-input").value = this.$store.getters.getSearchstr;
    }
  },
  computed: {
    ...mapGetters(["role","getAnalyticsFilter","getSearchstr"])
  },
  watch:{
    getAnalyticsFilter(obj){
      document.getElementById("search-input").value = "";
    }
  },
  methods: {
    ...mapActions([
      "clearToken",
      "sendSearchReq",
      "sendSearchReqLab",
      "setSerachString",
      "setSerachValue",
      "setPginationPage",
      "getAdminInfo",
      "profile",
      "sendSearchReqPending",
      "setWooOrdersData",
      "getAnalyticsInfoList",
      "getLabOperatorInfoList",
      "getAdminInfoList",
      "sendsearchAllReq",
      "setShowSearchAll",
      "setInventory",
      "getInactiveList"
    ]),
    async sendsearchAll(){
      this.loading = true;
      this.showSearchAll = false;
      this.setShowSearchAll(true);
      if(this.$store.getters.getComponentNum == 0) {
        await this.sendsearchAllReq();
      }
      this.loading = false;
    },
    closeModel() {
      this.showMenu = false;
    },
    logout() {
      this.showMenu = false;
      this.clearToken().then(res => {
        this.$router.push({ path: "/login" });
      });
    },
    setSearchStr(e) {
      this.setPginationPage(null);
      this.searchKey = e.target.value;
      if (this.$store.getters.getComponentNum == 15) {
        this.setSerachValue(this.parseKit(this.searchKey));
      } else {
        this.setSerachString(this.parseKit(this.searchKey));
      }

    },
    parseKit(kitId) {
      return kitId
        ? kitId.replace(/-/g, "")
        : null;
    },
    async sendsearchReq() {
      if(document.getElementById("search-input").value !== null) {
        this.showClose = true;
      }
      this.showSearchAll = true;
      this.loading = true;
      this.setShowSearchAll(true);
      if(this.role == 'laboperator') {
        const parseSearchKey = this.parseKit(this.searchKey)
        if(parseSearchKey == null) {
          return false;
        }else if(parseSearchKey.length < 11){
          return false;
        }else if(parseSearchKey.length > 11){
          return false;
        }
        await this.sendSearchReqLab();
      }
      if(this.$store.getters.getComponentNum == 11) {
          this.setWooOrdersData();
      } else if (this.steps!='' && this.steps == "4") {
        await this.sendSearchReqPending();
      } else if (this.$store.getters.getComponentNum == 3) {
        const data = this.$store.getters.getAnalyticsFilter;
        await this.getAnalyticsInfoList(data);
      } else if (this.$store.getters.getComponentNum == 1) {
        await  this.getAdminInfoList("admins");
      }  else if (this.$store.getters.getComponentNum == 14) {
        await  this.setInventory(); 
      } else if (this.steps!='' && this.steps == "2") {
        await  this.getLabOperatorInfoList("labOps");
      } else if (this.$store.getters.getComponentNum == 15) {
        await this.getInactiveList();
      } else {
        await this.sendSearchReq();
      }
      this.loading = false;
    },
    clearText(){
      this.showClose = false;
      document.getElementById("search-input").value = "";
    },
    async clear(){
      this.showClose = false;
      this.showSearchAll = false;
      this.setShowSearchAll(false);
      document.getElementById("search-input").value = "";
      this.setSerachValue("");
      this.setSerachString("");
      
      if(this.$store.getters.getComponentNum == 11) {
        await this.setWooOrdersData();
      } else if (this.$store.getters.getComponentNum == 3)
      {
        const data = this.getAnalyticsFilter;
        this.getAnalyticsInfoList(data);
      }
      else if (this.steps!='' && this.steps == "4")
      {
        await this.sendSearchReqPending();
      } 
      else if (this.$store.getters.getComponentNum == 1)
      {
        await this.getAdminInfoList("admins");
      } 
      else if (this.$store.getters.getComponentNum == 15)
      {
        await this.getInactiveList();
      }
      else if (this.steps!='' && this.steps == "2")
      {
        await this.getLabOperatorInfoList("labOps");
      } else {
        await this.sendSearchReq();
      }
    }
  },
  mounted(){
    this.setShowSearchAll(false);
  }
};
</script>

<style scoped>
.search-width {
  max-width: 412px;
  width: 100%;
}
.rownew {
  width: 100%;
}
.search-button {
  max-width: 412px;
  width: 100%;
  position: relative;
  background-color: #eee;
  border: 1px solid #eee;
  left: 0%;
  top: 0%;
  border-radius: 5px;
  transform: translate(0%, 0%);
}

.search {
  max-width: 412px;
  width: 100%;
  position: absolute;
  background-color: #eee;
  border: 1px solid #eee;
  left: 0%;
  top: 0%;
  border-radius: 5px;
  transform: translate(0%, 0%);
}
.search-input {
  font-size: 14px;
  font-weight: 500px;
  font-family: TTNormsMedium, sans-serif;
  width: 100%;
  padding: 10px 132px 10px 60px;
  border: none;
  background-color: #fff;
  outline: none;
  border-radius: 5px;
  transition: all 0.5s linear;
  margin-right: 10px;
}
.search-input::placeholder {
  color: #757575;
  font-family: TTNormsLight, sans-serif;
  opacity: 0.8;
}
.search-input:focus {
  background-color: #e3e3e3;
}


.search-icone-wrap {
  position: absolute;
  width: 20px;
  display: flex; /* Use flexbox to align items */
    align-items: center; /* Align items vertically */
}
.search-icone-wrap.right {
  right: 10px;
  top: 8px;
}
.search-icone-wrap.right-close {
  right: 22px;
  top: 8px;
}
.search-icone-wrap.left {
  left: 30px;
  top: 10px;
}
.search-icone-wrap.left img {
  max-width: 70%;
  height: auto;
}
.search-icone-wrap.right img {
  max-width: 100%;
  height: auto;
}

.loading-gif {
  width: 26px;
  height: 23.3833px;
  }
.btn-search {
  background-color: #b7bec6;
  color: #005eb8;
  max-width: 100px;
  width: 100%;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  outline: none;
  border: 1px solid transparent;
  font-size: 12px;
  font-family: TTNormsLight, sans-serif;
  padding: 6px 15px 6px 15px;
  height: 30px;
  margin: 6px 0px 0px 13px;
  cursor: pointer;
  border-radius: 5px;
}
.search-span{
  display: flex;
  max-width: 712px;
  width: 100%;
}
.btn {
  margin: 0px 5px 0px 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15px;
  height: 15px;
  padding: 0;
  border: 1px solid transparent;
  cursor: pointer;
  background-color: transparent;
  color: gray;
}
.btn img {
  max-width: 100%;
  height: 100%;
}
</style>
